import { render, staticRenderFns } from "./OpenExternal.vue?vue&type=template&id=7faa9e86&"
import script from "./OpenExternal.vue?vue&type=script&lang=js&"
export * from "./OpenExternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports